import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input, UncontrolledTooltip } from "reactstrap";

import {
  addDefaultSrc,
  getAudioClassification,
  isEmpty,
  secToHHMMSS,
} from "../../../utilities";
import { updateVideoPageState } from "../VideoActions";
import DropboxPlayer from "../../../Shared/DropboxPlayer";
import GenerateTiktokThumbnail from "../../../Shared/GenerateTiktokThumbnail";
import { CampaignTag, RatingStars } from "./RatingStars";

const analyzedIcon =
  require(`@src/assets/images/vyrill/videos/analyzed.png`).default;
const notAnalyzedIcon =
  require(`@src/assets/images/vyrill/videos/notAnalyzed.png`).default;
const pendingAnalysisIcon =
  require(`@src/assets/images/vyrill/videos/pendingAnalysis.png`).default;
const defaultThumbnail =
  require("@src/assets/images/vyrill/default.png").default;

const GenerateIcon = ({ width, height, path }) => {
  return (
    <img
      src={require(`@src/assets/images/vyrill/reports${path}`).default}
      style={{ width, height }}
    />
  );
};

const platformIcon = (item) => {
  switch (item.platform) {
    case "Youtube":
      return (
        <GenerateIcon width="24px" height="24px" path="/youtube_icon.png" />
      );

    case "Dropbox":
      return (
        <GenerateIcon width="25px" height="25px" path="/dropbox_icon.svg" />
      );

    case "Tiktok":
      return (
        <GenerateIcon width="25px" height="25px" path="/tiktok_icon.svg" />
      );
    case "Instagram":
      return (
        <GenerateIcon width="25px" height="25px" path="/instagram_icon.png" />
      );
    case "GoogleDrive":
      return (
        <GenerateIcon
          width="24px"
          height="22px"
          path="/google_drive_icon.png"
        />
      );

    default:
      return null;
  }
};

const VideoThumbnail = ({ item, handleOpenSinglePublish }) => {
  const [allPublished, setAllPublished] = useState(false);
  const uploadedTime = new moment(item.created_at);
  const currentTime = new moment(moment.utc().format());
  const duration = moment.duration(currentTime.diff(uploadedTime));
  const uploadedHours = parseInt(duration.asHours());
  const isUploadedInSession = localStorage.getItem("vidUploadedInSession");

  const isPublished =
    item?.additional_data?.data?.published_to_swirl ===
    "Successfully updated published status";

  const flaggedChecks = useSelector(
    (state) => state.videoPageStates.flaggedChecks
  );
  const favoriteChecks = useSelector(
    (state) => state.videoPageStates.favoriteChecks
  );
  const deleteChecks = useSelector(
    (state) => state.videoPageStates.deleteChecks
  );
  const isTrashTab = useSelector((state) => state.videoParams.isTrashTab);
  const isFlaggedTab = useSelector((state) => state.videoParams.isFlaggedTab);

  const restoreChecks = useSelector(
    (state) => state.videoPageStates.restoreChecks
  );

  const flaggedVideosCheckList = useSelector(
    (state) => state.videoPageStates.flaggedVideosCheckList
  );
  const favVideosCheckList = useSelector(
    (state) => state.videoPageStates.favVideosCheckList
  );
  const deleteVideosCheckList = useSelector(
    (state) => state.videoPageStates.deleteVideosCheckList
  );
  const restoreVideosCheckList = useSelector(
    (state) => state.videoPageStates.restoreVideosCheckList
  );
  const videoTab = useSelector((state) => state.videoParams.tab);
  const isCampaignTab = useSelector((state) => state.videoParams.isCampaignTab);
  const downloadVideosCheckList = useSelector(
    (state) => state.videoPageStates.downloadVideosCheckList
  );

  const publishVideosCheckList = useSelector(
    (state) => state.videoPageStates.publishVideosCheckList
  );
  const downloadVideoChecks = useSelector(
    (state) => state.videoPageStates.downloadVideoChecks
  );

  const publishVideoChecks = useSelector(
    (state) => state.videoPageStates.publishVideoChecks
  );
  const dispatch = useDispatch();
  const videoPageStates = useSelector((state) => state.videoPageStates);

  const videos = useSelector((state) => state.videos);
  useEffect(() => {
    const video = videos?.map((data) => data?.video);
    const publishedData = video?.map(
      (data) => data?.additional_data?.data?.published_to_swirl
    );
    const isPublishedSwirlArray = Array.isArray(publishedData);
    const allVideosPublished =
      isPublishedSwirlArray &&
      publishedData.every(
        (status) => status === "Successfully updated published status"
      );
    setAllPublished(allVideosPublished);
  }, [videos]);

  const renderNoSpeechIcon = (audioLabels) => {
    let speech = null;
    if (!isEmpty(item?.audio_labels)) {
      const audioL = getAudioClassification(audioLabels);
      speech = audioL?.speech;
    }
    return speech;
  };

  const DropboxThumbnail = (
    <div
      className="videoWrapper"
      style={{ width: "100%", height: "156px", objectFit: "contain" }}
    >
      <DropboxPlayer styleClass={"videoFrame"} videoUrl={item.video_url} />
    </div>
  );

  // const apiThumbnail = (
  //   <div className="videoWrapper">
  //     <video
  //       id={`S3-${item._id}`}
  //       className="videoFrame"
  //       width="100%"
  //       height="auto"
  //     >
  //       <source src={item.video_url} />
  //     </video>
  //   </div>
  // );

  // useEffect(() => {
  //   if (item && item.platform === "Vyrill_AWS_S3") {
  //     const video = document.getElementById(`S3-${item._id}`);
  //     video.addEventListener("loadedmetadata", function () {
  //       video.currentTime = 3;
  //     });
  //   }
  // }, [item._id]);

  // const youTubeThumbnail = (
  //   // <div className="vcardImgContainer">
  //   //   <div className="vcardImgWrapper">
  //   <div className="vcardImgThumbBox">
  //     <img
  //       width="100%"
  //       style={{
  //         height: "156px",
  //         objectFit: "contain",
  //         background: "black",
  //       }}
  //       src={
  //         item?.thumbnail_url ||
  //         require("@src/assets/images/vyrill/default.png").default
  //       }
  //       className="vcardImgThumbImg"
  //       alt="text"
  //     />
  //   </div>
  //   //   </div>
  //   // </div>
  // );

  const instagramThumbnail = (
    <img
      width="100%"
      style={{ height: "156px", objectFit: "contain", background: "black" }}
      src={item?.thumbnail_url}
      onError={(event) => addDefaultSrc(event, defaultThumbnail)}
      alt="text"
    />
  );

  const VideoThumbnail = (
    <img
      width="100%"
      style={{ height: "156px", objectFit: "contain", background: "black" }}
      src={
        item?.thumbnail_url ||
        require("@src/assets/images/vyrill/default.png").default
      }
      alt="text"
    />
  );

  const tiktokThumbnail = (
    <GenerateTiktokThumbnail
      video={item}
      customStyle={{ background: "black", height: "156px", overflow: "hidden" }}
      imgStyle={{ height: "inherit" }}
    />
  );

  const publishUnPublishIcon = (iconName) => (
    <img
      src={require(`@src/assets/images/vyrill/videos/${iconName}.png`).default}
      width={18}
      id={`publishWidget${item._id}`}
    />
  );

  const publishTag = (
    <div
      style={{
        background: isPublished ? "#783AD0" : "white",
        opacity: 0.5, 
        pointerEvents:  "none",
      }}
      className="publish-icon"
      role="button"
      onClick={(e) => {
        e.stopPropagation();
        if (!publishVideoChecks) {
          handleOpenSinglePublish();
        }
      }}
    >
      <UncontrolledTooltip
        style={{ background: "#E4F9F7", color: "black" }}
        placement="left"
        target={`publishWidget${item._id}`}
      >
        {isPublished ? "Unpublish" : "Publish"}
      </UncontrolledTooltip>
      {publishUnPublishIcon(
        isPublished ? "unPublishedSwirll" : "publishedSwirll"
      )}
    </div>
  );

  const handleFlaggingCheck = (event) => {
    const { target } = event;
    let checkedList = [];
    if (flaggedVideosCheckList.includes(target.id)) {
      // Removing item
      checkedList = flaggedVideosCheckList.filter((e) => e !== target.id);
    } else {
      // add new
      checkedList = [...flaggedVideosCheckList];
      checkedList.push(target.id);
    }
    dispatch(updateVideoPageState({ flaggedVideosCheckList: checkedList }));
  };

  const handleDeleteCheck = (event) => {
    const { target } = event;
    let checkedList = [];
    if (deleteVideosCheckList.includes(target.id)) {
      // Removing item
      checkedList = deleteVideosCheckList.filter((e) => e !== target.id);
    } else {
      // add new
      checkedList = [...deleteVideosCheckList];
      checkedList.push(target.id);
    }
    dispatch(updateVideoPageState({ deleteVideosCheckList: checkedList }));
  };

  const handleRestoreCheck = (event, restoreBtn = false) => {
    event.stopPropagation();
    const { target } = event;
    if (restoreBtn) {
      dispatch(
        updateVideoPageState({
          restoreVideosCheckList: [target.id],
          confirmRestore: true,
        })
      );
    } else {
      let checkedList = [];
      if (restoreVideosCheckList.includes(target.id)) {
        // Removing item
        checkedList = restoreVideosCheckList.filter((e) => e !== target.id);
      } else {
        // add new
        checkedList = [...restoreVideosCheckList];
        checkedList.push(target.id);
      }
      dispatch(updateVideoPageState({ restoreVideosCheckList: checkedList }));
    }
  };

  const handleFavCheck = (event) => {
    const { target } = event;
    let checkedList = [];
    if (favVideosCheckList.includes(target.id)) {
      // Removing item
      checkedList = favVideosCheckList.filter((e) => e !== target.id);
    } else {
      // add new
      checkedList = [...favVideosCheckList];
      checkedList.push(target.id);
    }
    dispatch(updateVideoPageState({ favVideosCheckList: checkedList }));
  };

  const handleDownloadCheck = (event) => {
    const { target } = event;
    let checkedList = [];
    if (downloadVideosCheckList.includes(target.id)) {
      // Removing item
      checkedList = downloadVideosCheckList.filter((e) => e !== target.id);
    } else {
      // add new
      checkedList = [...downloadVideosCheckList];
      checkedList.push(target.id);
    }
    dispatch(updateVideoPageState({ downloadVideosCheckList: checkedList }));
  };

  const handlePublishCheck = (event) => {
    const { target } = event;
    let checkedList = [];
    if (publishVideosCheckList.includes(target.id)) {
      // Removing item
      checkedList = publishVideosCheckList.filter((e) => e !== target.id);
    } else {
      // add new
      checkedList = [...publishVideosCheckList];
      checkedList.push(target.id);
    }
    dispatch(updateVideoPageState({ publishVideosCheckList: checkedList }));
  };

  const flaggCheck = () => (
    <div
      className="flag-check"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Input
        id={item._id}
        name={item._id}
        type="checkbox"
        onChange={handleFlaggingCheck}
        checked={flaggedVideosCheckList.includes(item._id)}
      />
    </div>
  );

  const favCheck = () => (
    <div
      className="flag-check"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Input
        id={item._id}
        name={item._id}
        type="checkbox"
        onChange={handleFavCheck}
        checked={favVideosCheckList.includes(item._id)}
      />
    </div>
  );

  const downloadVideoCheck = () => (
    <div
      className="flag-check"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Input
        id={item._id}
        name={item._id}
        type="checkbox"
        onChange={handleDownloadCheck}
        checked={downloadVideosCheckList.includes(item._id)}
      />
    </div>
  );
  const publishVideoCheck = () => (
    <div
      className="flag-check"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {(!isPublished || allPublished) && (
        <Input
          id={item._id}
          name={item._id}
          type="checkbox"
          onChange={handlePublishCheck}
          checked={publishVideosCheckList.includes(item._id)}
        />
      )}
    </div>
  );

  const trashCheck = () => (
    <div
      className="flag-check"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Input
        id={item._id}
        name={item._id}
        type="checkbox"
        onChange={handleDeleteCheck}
        checked={deleteVideosCheckList.includes(item._id)}
      />
    </div>
  );

  const restoreCheck = () => (
    <div
      className="flag-check"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Input
        id={item._id}
        name={item._id}
        type="checkbox"
        onChange={handleRestoreCheck}
        checked={restoreVideosCheckList.includes(item._id)}
      />
    </div>
  );

  const restoreButton = (
    <div
      role="button"
      className="RestoreButton"
      id={item._id}
      onClick={(e) => handleRestoreCheck(e, true)}
    >
      Restore
    </div>
  );

  const analysisIcon = (type) => {
    if (!type) {
      return;
    }
    const styleId = `${type}${item._id}`;
    const image = {
      pending: pendingAnalysisIcon,
      full_failure: notAnalyzedIcon,
      partial_failure: analyzedIcon,
      completed: analyzedIcon,
    };
    const tooltipText = {
      pending: "Pending Analysis",
      full_failure: "Not Analyzed",
      partial_failure: "Analyzed",
      completed: "Analyzed",
    };

    return (
      <span id={styleId} style={{ left: "8px" }} className="analysis-icon">
        <UncontrolledTooltip
          style={{ color: "#000000", background: "#E4F9F7" }}
          target={styleId}
          placement="top"
        >
          {tooltipText[type]}
        </UncontrolledTooltip>
        <img width={26} src={image[type]} />
      </span>
    );
  };

  const sentimentScore = (itemId) => (
    <span>
      <div
        id={`sentiment-score-${itemId}`}
        className="sentiment-score"
        style={{ fontSize: item?.gpt_sentiment_score === 100 ? "18px" : "" }}
      >
        {item?.gpt_sentiment_score || 0}
      </div>
      <UncontrolledTooltip
        placement="top"
        target={`sentiment-score-${itemId}`}
        style={{ color: "#000000", background: "#E4F9F7" }}
      >
        Sentiment Score out of 100
      </UncontrolledTooltip>
    </span>
  );

  const noSpeechIcon = (itemId) => {
    if (!itemId) return null;
    return (
      <span>
        <img
          width={30}
          id={`no-speech-${itemId}`}
          className="no-speech"
          src={require("@src/assets/images/vyrill/no-speech-icon.png").default}
        />
        <UncontrolledTooltip
          placement="top"
          target={`no-speech-${itemId}`}
          style={{
            color: "#000000",
            background: "#E4F9F7",
          }}
        >
          Videos with no speech
        </UncontrolledTooltip>
      </span>
    );
  };

  const newVideo = isUploadedInSession && uploadedHours <= 12;
  const apiVideo = item?.upload_method === "Vyrill_API";
  const noChecks =
    !deleteChecks &&
    !flaggedChecks &&
    !favoriteChecks &&
    !restoreChecks &&
    !downloadVideoChecks &&
    !publishVideoChecks;
  const showPublishIcon =
    !isTrashTab && !isFlaggedTab && videoTab !== "Competition";
  const showAPIIcon = !isTrashTab && !isFlaggedTab && !newVideo && apiVideo;
  const showNewIcon = !isTrashTab && noChecks && newVideo;

  const campaignVideo =
    (item?.platform == "Vyrill_AWS_S3" ||
      item?.platform == "Instagram" ||
      item?.platform === "Tiktok" ||
      item?.platform === "Youtube") &&
    (item?.upload_method == "Clip-up" || item?.upload_method == "Clip-Up");

  return (
    <div className="video-thumbnail">
      {/* Thumbnail as per the video platfrom */}
      {item.platform === "Dropbox" && item?.video_url && DropboxThumbnail}
      {/* {item.platform === "Youtube" && item?.thumbnail_url && youTubeThumbnail} */}
      {item.platform === "Tiktok" && item?.thumbnail_url && tiktokThumbnail}
      {item.platform === "Instagram" &&
        item?.thumbnail_url &&
        instagramThumbnail}
      {/* {item.platform === "GoogleDrive" && item?.thumbnail_url && DriveThumbnail}
      {item.platform === "Vyrill_AWS_S3" && item?.video_url && apiThumbnail} */}

      {(item.platform === "GoogleDrive" ||
        item.platform === "AWS_S3_Swirl" ||
        item.platform === "Youtube" ||
        item.platform === "Vyrill_AWS_S3") &&
        item?.thumbnail_url &&
        VideoThumbnail}

      {/* {item.platform === "Vyrill_AWS_S3" && item?.video_url && apiThumbnail} */}

      {/* Platfrom icons */}
      {campaignVideo ? (
        <>
          {" "}
          <span
            className="platform-icon"
            style={{ position: "absolute", top: "101px", left: "8px" }}
          >
            {platformIcon(item)}
          </span>
          <CampaignTag
            width={18}
            campaignName={`${item?.campaign?.campaign_name}`}
          />
        </>
      ) : (
        <span className="platform-icon">{platformIcon(item)}</span>
      )}
      {/* Video duration icon */}
      <div
        className="video-duration-icon"
        // style={{ right: isCampaignTab ? "15px" : "" }}
      >
        {item?.duration_in_seconds !== null &&
          secToHHMMSS(item?.duration_in_seconds)}
        {item?.duration_in_seconds === null &&
          secToHHMMSS(Number(item?.duration || "0"))}
      </div>
      {/* Analysis icons */}
      {noChecks && analysisIcon(item?.analysis_stage || "pending")}

      {/* Sentiment score */}
      {!(
        renderNoSpeechIcon(item?.audio_labels) === 0 ||
        renderNoSpeechIcon(item?.audio_labels) === null
      )
        ? sentimentScore(item?._id)
        : noSpeechIcon(item?._id)}

      {/* Publish icon */}
      {showPublishIcon && publishTag}

      {/* API icon for API videos */}
      {/* {showAPIIcon && !isCampaignTab && <span className="api-text">API</span>} */}

      {/* icon for new added videos */}
      {/* {showNewIcon && <span className="new-icon">New</span>} */}
      {campaignVideo && (
        <RatingStars width={18} rating={item?.campaign?.rating} />
      )}

      {/* {showAPIIcon && <span className="api-text">API</span>} */}

      {/* icon for new added videos */}
      {/* {showNewIcon &&
        !(
          item?.analysis_stage === "completed" ||
          item?.analysis_stage === "full_failure" ||
          item?.analysis_stage === "partial_failure"
        ) && <span className="new-icon">New</span>} */}

      {isTrashTab && !deleteChecks && restoreButton}
      {flaggedChecks && flaggCheck()}
      {favoriteChecks && favCheck()}
      {deleteChecks && trashCheck()}
      {downloadVideoChecks && downloadVideoCheck()}
      {publishVideoChecks && publishVideoCheck()}
      {restoreChecks && restoreCheck()}
    </div>
  );
};

export default React.memo(VideoThumbnail);
